(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-spotlight"] && !Shopify.designMode) return;
  try {
    
  /**
   * Button that presses the submit button of the main product form, with the size, pack and quantity
   * chosen there: the form keeps the single add to cart path.
   *
   * It is available exactly when the submit button of that form is: a sold out variant,
   * or a page without that form, leaves it disabled.
   */
  class MainFormSubmit extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.submit = document.querySelector('form[data-main-form] [type="submit"]');
      if (!(this.button instanceof HTMLButtonElement)) return;
      if (!(this.submit instanceof HTMLButtonElement)) {
        this.button.disabled = true;
        return;
      }

      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.submit, { attributes: true, attributeFilter: ['disabled'] });
      this.sync();
      this.button.addEventListener('click', this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this);
    }

    sync() {
      this.button.disabled = this.submit.disabled;
    }

    handleEvent() {
      this.submit.click();
    }
  }

  if (!customElements.get('main-form-submit')) customElements.define('main-form-submit', MainFormSubmit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-countdown"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.deadline = Number(this.dataset.deadline) * 1000;
      this.values = Object.fromEntries(
        [...this.querySelectorAll('[data-unit]')].map((element) => [element.dataset.unit, element])
      );
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const remaining = Math.max(0, this.deadline - Date.now());
      const parts = {
        days: Math.floor(remaining / 864e5),
        hours: Math.floor(remaining / 36e5) % 24,
        minutes: Math.floor(remaining / 6e4) % 60,
        seconds: Math.floor(remaining / 1e3) % 60,
      };
      for (const [unit, element] of Object.entries(this.values)) {
        element.textContent = String(parts[unit]).padStart(2, '0');
      }
      if (remaining === 0) this.end();
    }

    end() {
      clearInterval(this.interval);
      const message = this.querySelector('template');
      const region = this.querySelector('[aria-live]');
      if (!message || !region || region.childNodes.length > 0) return;
      this.querySelector('[role="timer"]').hidden = true;
      region.append(message.content.cloneNode(true));
    }
  }

  class CopyCode extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this);
    }

    async handleEvent(event) {
      const button = event.target.closest('button');
      if (!button) return;
      try {
        await navigator.clipboard.writeText(this.dataset.code);
      } catch {
        return;
      }
      button.textContent = this.dataset.copiedLabel;
      this.querySelector('[role="status"]').textContent = this.dataset.copiedLabel;
    }
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }

  if (!customElements.get('copy-code')) {
    customElements.define('copy-code', CopyCode);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signup-dialog"] && !Shopify.designMode) return;
  try {
    
  class SignupDialog extends HTMLElement {
    static seenKey = 'signup-dialog-seen';

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', this);
      this.addEventListener('keydown', this);
      this.addEventListener('ajax-form:submit', this);
      this.dialog.addEventListener('close', this);
      document.addEventListener('shopify:section:select', this);
      document.addEventListener('shopify:section:deselect', this);
      if (window.Shopify?.designMode) return;

      // A submission that fell back to a page reload comes back with its answer: the window shows it.
      customElements.whenDefined('ajax-form').then(() => {
        if (this.querySelector('ajax-form').dataset.outcome) this.dialog.showModal();
      });
      if (localStorage.getItem(SignupDialog.seenKey)) return;
      this.timer = setTimeout(() => this.openUnlessBusy(), Number(this.dataset.delay) * 1000);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('shopify:section:select', this);
      document.removeEventListener('shopify:section:deselect', this);
    }

    // Shopify's spam protection may show a challenge appended to the page: everything outside a modal
    // dialog is inert, so the window leaves the top layer for the time of the submission.
    releaseTopLayer() {
      if (!this.dialog.matches(':modal')) return;
      this.dialog.close();
      this.dialog.show();
    }

    openUnlessBusy() {
      if (!document.querySelector('dialog[open]')) this.dialog.showModal();
    }

    handleEvent(event) {
      switch (event.type) {
        case 'click':
          if (event.target === this.dialog || event.target.closest('[data-signup-close]')) this.dialog.close();
          break;
        case 'keydown':
          if (event.key === 'Escape' && !this.dialog.matches(':modal')) this.dialog.close();
          break;
        case 'ajax-form:submit':
          localStorage.setItem(SignupDialog.seenKey, '1');
          this.releaseTopLayer();
          break;
        case 'close':
          localStorage.setItem(SignupDialog.seenKey, '1');
          break;
        case 'shopify:section:select':
          if (event.detail.sectionId === this.dataset.sectionId && !this.dialog.open) this.dialog.show();
          break;
        case 'shopify:section:deselect':
          if (event.detail.sectionId === this.dataset.sectionId) this.dialog.close();
          break;
      }
    }
  }

  if (!customElements.get('signup-dialog')) {
    customElements.define('signup-dialog', SignupDialog);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  class SiteMenu extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.section = this.closest('.shopify-section');
      this.section.addEventListener('click', this);
    }

    disconnectedCallback() {
      this.section.removeEventListener('click', this);
    }

    handleEvent(event) {
      const target = event.target;
      if (target.closest('[data-menu-open]')) {
        this.dialog.showModal();
      } else if (target === this.dialog || target.closest('[data-menu-close]') || target.closest('.site-menu a')) {
        this.dialog.close();
      }
    }
  }

  if (!customElements.get('site-menu')) {
    customElements.define('site-menu', SiteMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"] && !Shopify.designMode) return;
  try {
    
  class StickyCta extends HTMLElement {
    connectedCallback() {
      const target = this.dataset.target?.startsWith('#') ? document.getElementById(this.dataset.target.slice(1)) : null;
      if (!target) return;
      this.observer = new IntersectionObserver(([entry]) => {
        this.toggleAttribute('data-concealed', entry.isIntersecting);
      });
      this.observer.observe(target);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('sticky-cta')) {
    customElements.define('sticky-cta', StickyCta);
  }

  } catch(e) { console.error(e); }
})();
})();
